import { render } from "preact";
import { App } from "./ui/App";
import { bootstrap } from "./actions";
import { composerDirty } from "./state";

const root = document.getElementById("app");
if (root) {
  render(<App />, root);
  void bootstrap();
}

// Warn before closing the tab while the composer has unsaved changes.
window.addEventListener("beforeunload", (e) => {
  if (composerDirty.value) {
    e.preventDefault();
    // Modern browsers ignore custom messages for security reasons
    // but still show a generic confirmation dialog when returnValue is set.
    e.returnValue = "You have unsaved changes. Do you really want to leave?";
  }
});
